enum HttpStatusCode {
    Forbidden = 403
}

export default HttpStatusCode;
